import React, { useCallback } from 'react';
import PermissionGates from 'components/PermissionGates';
import PERMISSIONS from 'permissionDefinitions';

import PortalPickerStyles from './styles';
import Row from '../../../components/Common/Row';
import Icon from '../../atoms/Icon';
import Typography from '../../atoms/Typography';

const CreatePortalButton = ({
  openPortalForm,
  closePortalPicker,
}: {
  openPortalForm: () => void;
  closePortalPicker: () => void;
}) => {
  const onClick = useCallback(() => {
    openPortalForm();
    closePortalPicker();
  }, [closePortalPicker, openPortalForm]);

  return (
    <PortalPickerStyles.CreatePortalDiv onClick={onClick}>
      <Row centerAlign>
        <Icon icon={'add'} color={'var(--color-status-info)'} />
        <Typography.Body
          type={'Button Text'}
          color={'var(--color-status-info)'}
        >
          Create Portal
        </Typography.Body>
      </Row>
    </PortalPickerStyles.CreatePortalDiv>
  );
};

const Gate = ({
  closePortalPicker,
  openPortalForm,
}: {
  closePortalPicker: () => void;
  openPortalForm: () => void;
}) => (
  <PermissionGates.Has
    requiredPermission={PERMISSIONS.CONTENT_ACCESS.CREATE_PORTALS}
  >
    <CreatePortalButton
      openPortalForm={openPortalForm}
      closePortalPicker={closePortalPicker}
    />
  </PermissionGates.Has>
);

export default Gate;
